/**
 * Nav v4
 * 
 */

'use strict';

/*!
 * hoverIntent v1.10.2 // 2020.04.28 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2019 Brian Cherne
 */
!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof module&&module.exports?module.exports=factory(require("jquery")):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";function track(ev){cX=ev.pageX,cY=ev.pageY}function isFunction(value){return"function"==typeof value}var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});function handleHover(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){!function(ev,$el,s,out){var data=$el.data("hoverIntent");data&&delete data[s.id],out.apply($el[0],[ev])}(ev,$el,state,cfg.out)},cfg.timeout)}}return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

export class Nav
{
  constructor()
  {
    this.selectors = {
      navbar:            $('nav.navbar'),
      main:              $('nav.navbar ul.navbar-nav'),
      dropdown:          $('nav.navbar li.dropdown'),
      toggle:            $('nav.navbar a.dropdown-toggle'),
      menu:              $('nav.navbar ul.dropdown-menu'),
      search_wrapper:    $('nav.navbar .c-v4-dropdown-search .c-v4-dropdown-search--results'), 
      search_input:      $('nav.navbar .c-v4-dropdown-search form.c-search-form input'),
      search_input_cancel: $('nav.navbar .c-v4-dropdown-search form.c-search-form span.after'),
      search_body:       $('nav.navbar .c-v4-dropdown-search .c-v4-dropdown-search--results-body'),
      search_link:       $('nav.navbar .c-v4-dropdown-search .c-v4-dropdown-search--results a.text-link'),
      mobile_back:       $('nav.navbar ul.dropdown-menu li.mobile-back > a'),
      mobile_toggler:    $('nav.navbar button.navbar-toggler'),
      mobile_menu:       $('nav.navbar .navbar-collapse'),
    };
    this.timeout = null;
    this.spinnerTimeout = null;
  }

  init()
  {
    this.init_dropdown_hover();
    this.init_mobile_dropdown();
    this.init_search_typeahead();
  }

  /**
   * Change dropdown to hover
   *
   * Bootstrap v4 doesn't support toggling by hover
   * 
   * @ref https://getbootstrap.com/docs/4.0/components/dropdowns/
   */
  init_dropdown_hover()
  {
    let _self = this;  

    // Run this as soon as possible for dropdowns to be available immediately on page load
    _self.set_dropdown_state();
    // Run again for on resizing to set mobile/desktop version
    $(window).on('resize orientationchange', function() {
      _self.set_dropdown_state();
    })
  }

  set_dropdown_state()
  {
    let _self = this;

    if ( window.innerWidth > 1150 )
    {
      _self.selectors.menu.add(_self.selectors.toggle).on('click', function ( e )
      {
        e.stopPropagation();
        e.stopImmediatePropagation();
      });

      _self.selectors.dropdown.hoverIntent({
        over: function()
        {
          openNavDropdown( $(this) );
        },
        out: function()
        {
          closeNavDropdown( $(this) );
        },
        timeout: 10
      });

      _self.selectors.dropdown.on('keydown', function (e) 
      {
        const toggle = $('a.dropdown-toggle', $(this));
        if (e.key === 'Enter') {
          e.preventDefault();
          // console.log('Enter key pressed');
          if ( toggle.attr('aria-expanded') == 'false') {
            openNavDropdown( $(this) );
          } else {
            closeNavDropdown( $(this) );
          }
        } else if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          // console.log('Escape key pressed');
          closeNavDropdown( $(this) );
          toggle.focus();
        }
      });

      _self.selectors.dropdown.on('focusout', function (e) 
      {
        // Check that focus has left the dropdown menu
        if (!e.currentTarget.contains(e.relatedTarget)) {
          closeNavDropdown( $(this) );
        }
      });

      function openNavDropdown( $this ) {
        let dropdown_menu = $('ul.dropdown-menu', $this);

        console.log( dropdown_menu );

        $('a.dropdown-toggle', $this).attr('aria-expanded', true);

        dropdown_menu.addClass('show');

        // Equalize column header height
        _self.equalize_column_header_height( $this );

        if ( ( ! $this.hasClass('is-language-dropdown') ) &&  (! dropdown_menu.hasClass('is-full-width') ) )
        {
          let w = dropdown_menu.outerWidth() / 2;

          dropdown_menu.css('left', 'calc(50% - ' + w + 'px)');
        }
      }

      function closeNavDropdown( $this ) {
        setTimeout( () => {
          let dropdown_menu = $('ul.dropdown-menu', $this);

          $('a.dropdown-toggle', $this).attr('aria-expanded', false);
          dropdown_menu.removeClass('show');
        }, 50);
      }

    }
    else
    {
      _self.selectors.dropdown.off('mouseenter mouseleave');
      _self.selectors.toggle.off('click').dropdown('update');

      _self.selectors.menu.on('click', function ( e )
      {
        e.stopPropagation();
      });
    }
  }

  /**
   * Init mobile dropdown menu
   * 
   */
  init_mobile_dropdown()
  {
    var _self = this;

    // Back to main menu
    _self.selectors.mobile_back.on('click', function()
    {
      let _el = $(this);

      _self.selectors.main.removeClass('submenu-open');

      /**
       * Manually close dropdown, Bootstrap v4 doesn't have a hide method
       * 
       * @link https://getbootstrap.com/docs/4.0/components/dropdowns/#methods
       */
      setTimeout( () => {
        _el.closest('.dropdown-menu')
          .removeClass('show')
          .prev('.dropdown-toggle')
          .attr('aria-expanded', false);
      }, 25);
    });
  }

  /**
   * Check if element is in viewport
   *
   * @param  DOMRect
   * @return boolean
   */
  is_in_viewport( bounding )
  {
    return ( ( bounding.left + bounding.width ) > window.innerWidth ) ? false : true;
  }

  /**
   * Search typeahead
   *
   * A 100ms setTimeout is used to debounce the search slightly. If there are
   * no results returned a spinner is loaded. If results are later found from
   * additional searches the spinner timeout is cleared and the results are shown.
   *
   * Otherwise the spinner spins for two seconds before showing a 'No Results' message.
   */
  init_search_typeahead()
  {
    let _self = this;

    this.selectors.search_input_cancel.on('click', function()
    {
      _self.selectors.search_wrapper.removeClass('active');
      _self.selectors.search_link.attr('href', '#');
      _self.selectors.search_input.val('');

      $(this).parent().removeClass('active');
    });

    this.selectors.search_input.on('keyup input', function()
    {
      clearTimeout(this.timeout);

      let value = $(this).val().trim();

      this.timeout = setTimeout(function() {

        if ( value == '' )
        {
          _self.selectors.search_wrapper.removeClass('active');
          _self.selectors.search_link.attr('href', '#');

          $(this).parent().removeClass('active');
        }
        else
        {
          _self.selectors.search_wrapper.addClass('active');
          $(this).parent().addClass('active');

          $.ajax({
            type:    'POST',
            url:     sysdigLocalizedObject.ajaxUrl,
            data:    {
              action: 'sysdig_v4_search',
              value:  value
            },
            success: function( resp )
            {
              if ( resp === '' ) {
                _self.show_spinner();
              } else {
                clearTimeout(_self.spinnerTimeout);
                _self.selectors.search_body.html( resp );
                _self.selectors.search_link.attr('href', '/?s=' + value);
              }
            }
          });
        }
      }, 100)
    });
  }

  /**
   * Equalize column headers
   *
   * @param jQuery dropdown
   */
  equalize_column_header_height( dropdown )
  {
    let h = 0;

    $('.nav-column-header', dropdown).each(function()
    {
      h = ( h < $(this).outerHeight() ) ? $(this).outerHeight() : h;
    });

    $('.nav-column-header', dropdown).css('height', h);
  }

  /**
   * Shows a spinner for 2 seconds
   *
   * Sets the search body to a spinner component.
   *
   * If the function is run again from continued input keyups, it clears the
   * timeout and sets a new one.
   *
   * After the timeout finishes the body of the results is set to 'No Results'
   */
  show_spinner() {

    let _self = this;

    _self.selectors.search_body.html( '<div class="c-spinner"></div>' );

    clearTimeout(this.spinnerTimeout);

    this.spinnerTimeout = setTimeout( function() {
      _self.selectors.search_body.html( '<div class="c-v4-dropdown-search--results-body-item pb-4">No results</div>')
    }, 2000 );
  }
}